/** InsCoder WANG.J 2025-09-01 B + Collapse table interaction JavaScript **/

document.addEventListener('DOMContentLoaded', function() {
  // 查找所有的折叠表格 section
  const sections = document.querySelectorAll('.cust-collapse-table');
  
  sections.forEach(function(section) {
    const tabs = section.querySelectorAll('.cust-collapse-table__tab');
    const images = section.querySelectorAll('.cust-collapse-table__image');
    
    if (tabs.length === 0 || images.length === 0) return;
    


    if(window.innerWidth < 769){
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.click();
          }
        });
      }, {
        root: document.querySelector('.cust-collapse-table__tabs'), // 容器
        threshold: 0.8
      });

      tabs.forEach(item => observer.observe(item));
    }

    // 为每个标签页添加点击事件
    tabs.forEach(function(tab, index) {
      tab.addEventListener('click', function() {
        const tabIndex = this.getAttribute('data-tab');
        if(window.innerWidth < 769){
          // this.scrollIntoView({
          //   behavior: "smooth",
          //   block: "nearest",  
          //   inline: "center" 
          // });
        }
        const currentActiveImage = section.querySelector('.cust-collapse-table__image.active');
        const targetImage = section.querySelector('.cust-collapse-table__image[data-tab="' + tabIndex + '"]');
        
        // 如果点击的是当前活动的标签，不执行切换
        if (this.classList.contains('active')) return;
        
        // 移除所有标签的活动状态
        tabs.forEach(function(t) {
          t.classList.remove('active');
        });
        
        // 添加当前标签的活动状态
        this.classList.add('active');
        
        // 图片切换动画
        if (currentActiveImage && targetImage && currentActiveImage !== targetImage) {
          // 当前图片淡出并放大
          currentActiveImage.classList.add('fade-out');
          currentActiveImage.classList.remove('initial', 'animate');
          
          // 延迟后移除当前图片的活动状态，并显示新图片
          setTimeout(function() {
            currentActiveImage.classList.remove('active', 'fade-out');
            targetImage.classList.add('active');
            targetImage.classList.remove('initial', 'animate');
          }, 300); // 等待淡出动画的一半时间
        } else if (targetImage) {
          // 如果没有当前活动图片，直接显示目标图片
          targetImage.classList.add('active');
          targetImage.classList.remove('initial', 'animate');
        }
        
        // // 添加点击动画效果
        // this.style.transform = 'scale(0.98)';
        // setTimeout(function() {
        //   tab.style.transform = 'scale(1)';
        // }, 150);
      });
      
      // 添加悬停效果
    //   tab.addEventListener('mouseenter', function() {
    //     if (!this.classList.contains('active')) {
    //       this.style.transform = 'translateX(10px)';
    //     }
    //   });
      
    //   tab.addEventListener('mouseleave', function() {
    //     if (!this.classList.contains('active')) {
    //       this.style.transform = 'translateX(0)';
    //     }
    //   });
    });
    
    // 键盘导航支持
    section.addEventListener('keydown', function(e) {
      const activeTab = section.querySelector('.cust-collapse-table__tab.active');
      if (!activeTab) return;
      
      let nextTab = null;
      
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
        nextTab = activeTab.nextElementSibling;
        if (!nextTab) {
          nextTab = section.querySelector('.cust-collapse-table__tab:first-child');
        }
      } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
        nextTab = activeTab.previousElementSibling;
        if (!nextTab) {
          nextTab = section.querySelector('.cust-collapse-table__tab:last-child');
        }
      }
      
      if (nextTab) {
        e.preventDefault();
        nextTab.click();
        nextTab.focus();
      }
    });
    
    // 使第一个标签页可聚焦
    const firstTab = section.querySelector('.cust-collapse-table__tab:first-child');
    if (firstTab) {
      firstTab.setAttribute('tabindex', '0');
    }
    
    // 为第一张图片添加初始加载动画
    const firstImage = section.querySelector('.cust-collapse-table__image.initial');
    if (firstImage) {
      // 延迟后触发动画
      setTimeout(function() {
        firstImage.classList.add('animate');
      }, 200);
    }
  });
});

/** InsCoder WANG.J 2025-09-01 E + Collapse table interaction JavaScript **/
